export const environment = {
    production: true,
    hmr: false,

    // -----------------------------------------
    //      @ BACKEND
    // -----------------------------------------
    backEnd: 'https://testing-api.medray.net',

    // -----------------------------------------
    //      @ APP SECURITY
    // -----------------------------------------
    issuer: 'https://testing-auth.medray.net',
    clientId: 'medcilia-admin',
    scope: 'openid profile administration',
    redirectUri: 'https://testing-ams.medray.net/',
    silentRefreshRedirectUri: 'https://testing-ams.medray.net/silent-refresh.html',
    postLogoutRedirectUri: 'https://testing-ams.medray.net/',

    // -----------------------------------------
    //      @ GRAPGQL
    // -----------------------------------------
    GQL_SCHEMA_VERSION: '0.2'
};
